import type { DashboardItem } from '../types/dashboard.types';
import { normaliseThirdPartyVrm } from './thirdPartyVrm';

export const THIRD_PARTY_AGREEMENT_PATH = '/agreements/third-party';

export const isThirdPartyRow = (row: DashboardItem): boolean => row.source === 'third_party';

export const thirdPartyAgreementPath = (row: DashboardItem): string | undefined => {
    const vrm = normaliseThirdPartyVrm(row.vehicle_vrm);
    const reference = row.reference?.trim();

    return vrm && reference ? `${THIRD_PARTY_AGREEMENT_PATH}?${new URLSearchParams({ vrm, reference })}` : undefined;
};
